export default "__VITE_ASSET__B0P6nIZy__"